/**
 * Layout wrapper for SDK documentation pages.
 * Renders the SDK sidebar + scrollable content area with <Outlet />.
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import SdkSidebar from './SdkSidebar';

export default function SdkLayout() {
  return (
    <div className="sdk-layout">
      <SdkSidebar />
      <main className="sdk-content">
        <Outlet />
      </main>
    </div>
  );
}
